import React, { Ref } from 'react'
import { CheckBox } from '@dasa-health/components-react'
import { FieldHookConfig, useField } from 'formik'
import { FormCheckboxWrapper } from './style'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'
import { useLocation } from 'react-router-dom'

type FormikCustomFieldProps = {
    className?: string
    dataTestId?: string
    termsRef?: Ref<HTMLDivElement> | undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & FieldHookConfig<any>

export const FormikCustomCheckbox = ({ className, dataTestId, termsRef, ...props }: FormikCustomFieldProps) => {
    const [field, meta] = useField(props)
    const { dispatchAnalyticsEvent } = useSignUpAnaytics()
    const { pathname } = useLocation()
    const nameEvent = (pathName: string) => {
        if (pathName === '/recuperar-senha') {
            return 'reset_password'
        }
        return 'cadastro_web'
    }

    const label = (
        <span className="form__subtitle__link">
            Li e aceito os{' '}
            <a href="/termos-de-uso" target="__blank">
                {' '}
                Termos de Uso{' '}
            </a>{' '}
            e o{' '}
            <a href="/aviso-de-privacidade" target="__blank">
                {' '}
                Aviso de Privacidade{' '}
            </a>
        </span>
    )
    return (
        <FormCheckboxWrapper ref={termsRef}>
            <CheckBox
                className={className ?? `form__checkbox ${meta.touched && meta.error ? 'form__checkbox--error' : ''}`}
                data-testid={dataTestId}
                defaultChecked={field.value}
                label={(label as unknown) as string}
                name={props.name}
                onBlur={e => {
                    field.onBlur(e)
                    dispatchAnalyticsEvent('personalDataOnFieldBlur', {
                        name: nameEvent(pathname),
                        fieldName: e.target.name,
                        errorMessage: meta.error,
                    })
                }}
                onChange={field.onChange}
                sx={{ alignItems: 'flex-start' }}
            />
            {meta.touched && meta.error && <span className="checkbox-error-message">{meta.error}</span>}
        </FormCheckboxWrapper>
    )
}
